import { render } from "./CreateMaterialPage.vue?vue&type=template&id=134213e7"
import script from "./CreateMaterialPage.vue?vue&type=script&lang=js"
export * from "./CreateMaterialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__